import React from 'react';
import { Shield, Smartphone, Lock, CheckCircle2 } from 'lucide-react';

export const BrandHero = () => {
  return (
    <div className="space-y-5 font-sans">
      {/* Top Header & Security Status */}
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-3">
          <img src="/win-ai-trade-icon.svg" alt="Win AI Trade" className="w-9 h-9 flex-shrink-0 drop-shadow-[0_0_8px_rgba(0,242,254,0.5)]" />
          <div>
            <div className="font-extrabold text-sm text-white font-mono tracking-wide">
              WIN <span className="text-[#00f2fe]">AI</span> <span className="text-[#10b981]">TRADE</span>
            </div>
            <div className="text-[10px] text-slate-400 font-mono">NỀN TẢNG PHÂN TÍCH & GIAO DỊCH THỂ CHẾ</div>
          </div>
        </div>

        <div className="flex items-center gap-1.5 px-3 py-1 rounded-full bg-cyan-950/40 border border-cyan-500/30 text-cyan-400 text-xs font-mono">
          <span className="w-1.5 h-1.5 rounded-full bg-cyan-400 animate-pulse" />
          <span>TRUY CẬP BẢO MẬT</span>
        </div>
      </div>

      {/* Main Title & Hero Copy */}
      <div className="space-y-1.5 pt-2">
        <span className="text-xs font-mono font-bold text-cyan-400 uppercase tracking-widest">
          KHU VỰC ĐĂNG NHẬP
        </span>
        <h1 className="text-3xl sm:text-4xl font-extrabold text-white tracking-tight">
          Đăng nhập vào Win AI Trade
        </h1>
        <p className="text-xs sm:text-sm text-slate-400 leading-relaxed pt-1">
          Truy cập khu vực phân tích, theo dõi thị trường và quản lý tài khoản của bạn trên nền tảng Win AI Trade Terminal.
        </p>
      </div>

      {/* 2 Fast Feature Cards */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 pt-1">
        <div className="rounded-2xl bg-[#0c101a] border border-white/10 p-4 space-y-1">
          <span className="text-[10px] font-mono text-slate-500 block uppercase font-bold tracking-wider">
            TÀI KHOẢN
          </span>
          <h4 className="text-xs font-bold text-white">Truy cập nhanh vào hệ thống</h4>
          <p className="text-[11px] text-slate-400 leading-relaxed font-sans pt-0.5">
            Đăng nhập để tiếp tục với không gian làm việc và các công cụ được cấp cho tài khoản của bạn.
          </p>
        </div>

        <div className="rounded-2xl bg-[#0c101a] border border-white/10 p-4 space-y-1">
          <span className="text-[10px] font-mono text-slate-500 block uppercase font-bold tracking-wider">
            HỖ TRỢ
          </span>
          <h4 className="text-xs font-bold text-white">Sẵn sàng trên nhiều thiết bị</h4>
          <p className="text-[11px] text-slate-400 leading-relaxed font-sans pt-0.5">
            Tối ưu cho desktop và mobile. Khi cần hỗ trợ truy cập, bạn có thể liên hệ trực tiếp qua Telegram.
          </p>
        </div>
      </div>

      {/* Card 3: LƯU Ý SỬ DỤNG - THÔNG TIN QUAN TRỌNG */}
      <div className="rounded-2xl bg-[#0c101a] border border-white/10 p-4 space-y-2.5 text-xs text-slate-300">
        <div className="flex items-center justify-between">
          <h4 className="font-bold text-white uppercase text-xs font-mono">LƯU Ý SỬ DỤNG</h4>
          <span className="text-[10px] font-mono text-slate-400 px-2 py-0.5 rounded bg-white/5 border border-white/10">
            THÔNG TIN QUAN TRỌNG
          </span>
        </div>
        <p className="text-[11px] text-slate-300 leading-relaxed">
          Vui lòng kiểm tra kỹ thông tin tài khoản trước khi đăng nhập và chủ động bảo mật thông tin truy cập của bạn. Người dùng nên tự đánh giá mục tiêu giao dịch, mức chấp nhận rủi ro và kế hoạch quản lý lệnh trước khi tham gia thị trường.
        </p>
        <ul className="space-y-1 text-[11px] text-slate-400 pt-1">
          <li>• Thông tin đăng nhập nên được lưu trữ và sử dụng trên thiết bị đáng tin cậy.</li>
          <li>• Giao dịch tài chính luôn đi kèm rủi ro và không có kết quả được đảm bảo tuyệt đối.</li>
          <li>• Người dùng nên tuân thủ kế hoạch giao dịch và nguyên tắc quản trị rủi ro của mình.</li>
        </ul>
      </div>

      {/* Bottom Pills */}
      <div className="flex flex-wrap gap-2 pt-1 font-mono text-[10px]">
        <span className="px-2.5 py-1 rounded-lg bg-white/5 border border-white/10 text-slate-400">BẢO MẬT</span>
        <span className="px-2.5 py-1 rounded-lg bg-white/5 border border-white/10 text-slate-400">DESKTOP & MOBILE</span>
        <span className="px-2.5 py-1 rounded-lg bg-white/5 border border-white/10 text-slate-400">HỖ TRỢ TRUY CẬP</span>
        <span className="px-2.5 py-1 rounded-lg bg-white/5 border border-white/10 text-slate-400">TÀI KHOẢN ĐƯỢC CẤP QUYỀN</span>
      </div>
    </div>
  );
};

export default BrandHero;
